import { render, staticRenderFns } from "./packageDialog.vue?vue&type=template&id=dde3178a&scoped=true"
import script from "./packageDialog.vue?vue&type=script&lang=js"
export * from "./packageDialog.vue?vue&type=script&lang=js"
import style0 from "./packageDialog.vue?vue&type=style&index=0&id=dde3178a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde3178a",
  null
  
)

export default component.exports